import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=f6e57ac2&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=js&"
export * from "./Books.vue?vue&type=script&lang=js&"
import style0 from "./Books.vue?vue&type=style&index=0&id=f6e57ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e57ac2",
  null
  
)

export default component.exports